import { SelectOption } from '@doveit/bricks';
import { omit } from 'lodash';
import { IntentSource } from '../../../../domain/types';
import { intentSourceLabels } from '../../../../labels';
import { asSelectOptions } from '../../../../select-options/utils/asSelectOptions';

export const INTENT_SOURCE_OPTIONS: SelectOption[] = asSelectOptions(omit(intentSourceLabels, IntentSource.MATCHING));

export default INTENT_SOURCE_OPTIONS;
